import { PLACEHOLDER } from "./site";

// TEAM: isi data asli di sini. `details` menerima { id: "...", en: "..." } per field;
// `photo` menerima URL foto. Field kosong otomatis menampilkan placeholder.
const base = (n) => ({
  slug: `profil-psikolog-${n}`,
  photo: null,
  details: {},
});

export const PSYCHOLOGISTS = [1, 2, 3].map((n) => ({
  ...base(n),
  name: {
    id: `Psikolog Bali Empower ${n}`,
    en: `Bali Empower Psychologist ${n}`,
  },
  title: {
    id: "Psikolog — Profil segera hadir",
    en: "Psychologist — Profile coming soon",
  },
  bio: {
    id: "Profil lengkap tenaga profesional ini sedang disiapkan dan akan dilengkapi oleh tim Bali Empower, termasuk nama, kredensial, pendidikan, nomor izin praktik, area praktik, dan pengalaman.",
    en: "This professional's full profile is being prepared and will be completed by the Bali Empower team, including name, credentials, education, license/registration, areas of practice and experience.",
  },
  placeholder: PLACEHOLDER,
}));

export const PROFILE_FIELDS = [
  { key: "credentials", label: { id: "Kredensial", en: "Credentials" } },
  { key: "education", label: { id: "Pendidikan", en: "Education" } },
  { key: "license", label: { id: "Izin Praktik / Registrasi", en: "License / Registration" } },
  { key: "practiceAreas", label: { id: "Area Praktik", en: "Areas of Practice" } },
  { key: "clientGroups", label: { id: "Kelompok Klien", en: "Client Groups" } },
  { key: "languages", label: { id: "Bahasa", en: "Languages" } },
  { key: "approaches", label: { id: "Pendekatan Terapi", en: "Therapeutic Approaches" } },
  { key: "memberships", label: { id: "Keanggotaan Profesional", en: "Professional Memberships" } },
  { key: "experience", label: { id: "Pengalaman", en: "Experience" } },
  { key: "availability", label: { id: "Ketersediaan Konsultasi", en: "Consultation Availability" } },
];
